import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";

import NotFoundView from "../errors/NotFoundView";
import Compare from "./Compare";
import Details from "./Details";
import Diff from "./Diff";
import List from "./List";

const View: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Routes>
      <Route index element={<List />} />
      <Route path="diff/:entityType/:entityId" element={<Diff />} />
      <Route path=":changesetId/compare" element={<Compare />} />
      <Route path=":changesetId/details" element={<Details />} />
      <Route path="*" element={<NotFoundView />} />
    </Routes>
  );
};

export default View;
